import { render, staticRenderFns } from "./OldLandAreaForm.vue?vue&type=template&id=20141563&scoped=true&"
import script from "./OldLandAreaForm.vue?vue&type=script&lang=js&"
export * from "./OldLandAreaForm.vue?vue&type=script&lang=js&"
import style0 from "./OldLandAreaForm.vue?vue&type=style&index=0&id=20141563&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20141563",
  null
  
)

export default component.exports